import * as React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const TbLessThanIcon = () => {
    return (
        <SvgIcon>
            <polygon points="15.5 7.1 14.46 6.06 9.55 10.96 9.55 10.96 8.5 12 14.42 17.94 15.46 16.91 10.59 12.01 15.5 7.1" />
        </SvgIcon>
    );
};
